const alertContainerStyle = {
  borderRadius: '4px',
  overflow: 'hidden',
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box' as const,
  minWidth: 0,
};

const alertBoxStyle = {
  padding: '0',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: '0',
  margin: '0',
  width: '100%',
  boxSizing: 'border-box' as const,
  minWidth: 0,
  px: '14px',
  '& .MuiAlert-icon': {
    marginRight: '8px',
    fontSize: '20px',
  },
};

const messageTypographyStyle = {
  fontSize: '0.875rem',
  lineHeight: 1.5,
  wordBreak: 'break-word' as const,
};

export { alertBoxStyle, alertContainerStyle, messageTypographyStyle };
